module.exports = __webpack_public_path__ + "static/media/udemy.13078d37.png";